<template>
  <v-card color="#F5F5F5" class="back pa-4 mt-0 report-card">
    <v-card-title>
      1.8 - {{ $t('Corretivas Solicitadas x Executadas - Acumulado') }}
    </v-card-title>
    <v-divider></v-divider>
    <v-alert type="error" class="mt-3 pa-0" v-if="!showChart">
      {{ $t('Nenhuma corretiva encontrada') }}
    </v-alert>
    <v-card-text v-else>
      <v-row justify="center">
        <v-col cols="12" lg="8">
          <BarChart
            :chart-data="correctiveScheduleXExecutedChartData"
            :options="options"
          />
        </v-col>
      </v-row>

      <v-simple-table class="main-table" dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left"></th>
              <th class="text-left"></th>
              <th
                class="text-left"
                v-for="month in data.dataByMonth.map((x) => x.month)"
                :key="month"
              >
                {{ month }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="max-width: 60px"></td>
              <td style="max-width: 60px">
                {{ $t('Corretiva solicitada (interna)') }}
              </td>
              <td v-for="item in data.dataByMonth" :key="item.month">
                {{ item.internalCorrectiveSchedule }}
              </td>
            </tr>
            <tr>
              <td style="max-width: 60px"></td>
              <td style="max-width: 60px">
                {{ $t('Corretiva executada (interna)') }}
              </td>
              <td v-for="item in data.dataByMonth" :key="item.month">
                {{ item.internalCorrectiveExecuted }}
              </td>
            </tr>
            <tr>
              <td style="max-width: 60px"></td>
              <td style="max-width: 60px">
                {{ $t('Corretiva solicitada (total)') }}
              </td>
              <td v-for="item in data.dataByMonth" :key="item.month">
                {{ item.totalCorrectiveSchedule }}
              </td>
            </tr>
            <tr>
              <td style="max-width: 60px"></td>
              <td style="max-width: 60px">
                {{ $t('Corretiva executada (total)') }}
              </td>
              <td v-for="item in data.dataByMonth" :key="item.month">
                {{ item.totalCorrectiveExecuted }}
              </td>
            </tr>
            <tr style="background: #0288d1">
              <td style="max-width: 60px"></td>
              <td style="max-width: 60px; color: white !important">
                {{ $t('Porcentagem (total)') }}
              </td>
              <td
                style="color: white !important"
                v-for="item in data.dataByMonth"
                :key="item.month"
              >
                {{ `${item.totalPercentage}%` }}
              </td>
            </tr>
            <tr style="background: #bbcf20">
              <td style="max-width: 60px"></td>
              <td style="max-width: 60px; color: white !important">
                {{ $t('Porcentagem (interna)') }}
              </td>
              <td
                style="color: white !important"
                v-for="item in data.dataByMonth"
                :key="item.month"
              >
                {{ `${item.percentage}%` }}
              </td>
            </tr>
            <!-- <tr style="background: orange">
              <td style="max-width: 60px"></td>
              <td style="font-weight: bold; color: white !important">Meta</td>
              <td
                style="color: white !important"
                v-for="item in data.dataByMonth"
                :key="item.month"
              >
                {{ `${data.goal}%` }}
              </td>
            </tr> -->
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
import BarChart from '../../../../Reports/components/charts/barChart'

export default {
  props: {
    filter: Object,
  },
  components: {
    BarChart,
  },
  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      correctiveScheduleXExecuted: undefined,
      showChart: true,
      page: 1,
      totalPages: 1,
      pageSize: 7,
      percent: 0,
      data: {
        dataByMonth: [],
      },
      options: {
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      correctiveScheduleXExecutedChartData: {},
      totalCorrectiveSchedule: [],
      totalCorrectiveExcecuted: [],
      internalCorrectiveExecuted: [],
      internalCorrectiveSchedule: [],
      labels: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      correctiveScheduleXExecutedHeader: [
        {
          text: 'Tipo',
          align: 'center',
          value: 'type',
        },
        {
          text: 'Corretiva Solicitada',
          align: 'center',
          value: 'totalCorrectiveSchedule',
        },
        {
          text: 'Corretiva Executada',
          align: 'center',
          value: 'totalCorrectiveExcecuted',
        },
      ],
      total: 0,
    }
  },
  async created() {
    this.listcorrectiveScheduleXExecutedHeader()
  },
  methods: {
    async listcorrectiveScheduleXExecutedHeader() {
      await this.apiService
        .post('bigData/correctiveScheduleExecuted', this.filter)
        .then((response) => {
          this.data = response.content
          this.fillcorrectiveScheduleXExecutedChartData()
        })
        .catch((err) => {})
    },

    fillcorrectiveScheduleXExecutedChartData() {
      this.correctiveScheduleXExecutedChartData = {
        labels: this.data.dataByMonth.map((x) => x.month),
        datasets: [
          {
            label: 'Execução total',
            data: this.data.dataByMonth.map((x) => x.totalPercentage),
            backgroundColor: '#0288d1',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
          {
            label: 'Execução interna',
            data: this.data.dataByMonth.map((x) => x.percentage),
            backgroundColor: '#bbcf20',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
        ],
      }
    },
  },
  watch: {
    page() {
      this.filter.page = this.page
      this.listcorrectiveScheduleXExecutedHeader()
    },
  },
}
</script>
